module.exports = __webpack_public_path__ + "static/img/icon-04.e2572ea0.png";